var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 12,
    viewBox: "0 0 22 12",
    style: {
      transform: "rotate(90deg)",
      transformOrigin: "center"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.848503 1.15039C1.12281 0.900391 1.44759 0.775391 1.82284 0.775391C2.19736 0.775391 2.52177 0.900391 2.79607 1.15039L10.8332 8.47539L18.8978 1.12539C19.1538 0.892057 19.4738 0.775391 19.8579 0.775391C20.2419 0.775391 20.5711 0.900391 20.8454 1.15039C21.1197 1.40039 21.2568 1.69639 21.2568 2.03839C21.2568 2.37972 21.1197 2.67539 20.8454 2.92539L11.6013 11.3254C11.4916 11.4254 11.3727 11.4964 11.2447 11.5384C11.1167 11.5797 10.9795 11.6004 10.8332 11.6004C10.6869 11.6004 10.5498 11.5797 10.4218 11.5384C10.2938 11.4964 10.1749 11.4254 10.0652 11.3254L0.821072 2.90039C0.565054 2.66706 0.437044 2.37972 0.437044 2.03839C0.437044 1.69639 0.574198 1.40039 0.848503 1.15039Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.1fb4db714e0a449106eeea709548a440.svg";
export { ForwardRef as ReactComponent };